import React from 'react';

interface PageHeaderProps {
  title: string;
  eyebrow?: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, eyebrow, subtitle, action }) => (
  <header className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
    <div>
      {eyebrow && (
        <div className="flex items-center gap-2 mb-2">
          <span
            className="inline-block h-1 w-6 rounded-full bg-primary"
            aria-hidden="true"
          />
          <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-muted-foreground tabular-nums">
            {eyebrow}
          </p>
        </div>
      )}
      <h1 className="font-display font-bold tracking-tight text-foreground leading-[1.02] text-[2rem] sm:text-[2.5rem]">
        {title}
      </h1>
      {subtitle && (
        <p className="text-muted-foreground text-sm mt-1.5 max-w-xl">{subtitle}</p>
      )}
    </div>
    {action && <div className="flex gap-2 shrink-0 self-start sm:self-end">{action}</div>}
  </header>
);
